import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DashboardWidget, DashboardWidgetCreate, DashboardWidgetFilter } from '../data/dashboardWidget';

export function createDashboardWidgetService(client: AxiosInstance) {
  return createCrudService<DashboardWidget, DashboardWidgetCreate, DashboardWidgetFilter>(
    client,
    '/reporting/DashboardWidget',
    'id',
  );
}

export type DashboardWidgetService = CrudService<DashboardWidget, DashboardWidgetCreate, DashboardWidgetFilter>;
